<!-- Project: GSSC Pilot Front-end -->
<!-- Filename: SaveFilterModal.vue -->
<!-- Copyright European Space Agency, 2020 -->
<!-- This file is part of the source code package for contract PO PO 5001024866 -->
<!-- No part of the package, including this file, may be copied, modified,      -->
<!-- propagated, or distributed without prior approval by ESA.                  -->
<template>
  <div class="modal save-filter-modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <button
            type="button"
            class="modal__close close"
            data-dismiss="modal"
            aria-label="Close"
            @click="$emit('closeModal')"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form>
            <div class="form-group">
              <label for="name">Name</label>
              <input
                ref="firstInput"
                v-model="name"
                type="text"
                class="modal__name form-control"
                id="name"
              />
            </div>
            <div class="form-group">
              <label for="description">Description</label>
              <input v-model="desc" type="text" class="modal__desc form-control" id="description" />
            </div>
            <button class="modal__saveedit btn btn-primary float-right" @click.prevent="saveOrEdit">
              Save
            </button>
          </form>
        </div>
        <div class="modal-footer"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from '@/lib/api'

export default {
  name: 'SaveFilterModal',
  data() {
    return {
      name: this.initName,
      desc: this.initDesc,
    }
  },
  props: {
    // the route query to save
    query: Array,
    // Existing filter props
    id: {
      type: Number,
      required: false,
    },
    initName: {
      type: String,
      default: '',
    },
    initDesc: {
      type: String,
      default: '',
    },
  },
  computed: {
    title() {
      return this.id ? 'Edit Filter' : 'Save Filter'
    },
  },
  methods: {
    async saveOrEdit() {
      if (this.id) {
        this.editFilter()
      } else {
        this.saveFilter()
      }
    },
    // Save the filter
    async saveFilter() {
      const response = api.saveFilter(this.name, this.desc, this.query)
      if (response) {
        $('.save-filter-modal').modal('hide')
      }
    },
    // Edit filter
    async editFilter() {
      const response = await api.editFilter(this.id, this.name, this.desc, this.query)

      if (response) {
        $('.save-filter-modal').modal('hide')
        this.$emit('filter-saved')
        this.$emit('closeEditModal')
      }
    },
    updateForm() {
      this.name = this.initName
      this.desc = this.initDesc
    },
  },
  mounted() {
    this.updateForm()
    $('.save-filter-modal').on('shown.bs.modal', () => {
      this.$refs.firstInput.focus()
    })
  },
  watch: {
    initName: function() {
      this.updateForm()
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss"></style>
